import { retrieveClaimTypesQueryOptions } from "@/lib/data/react-query/matters/claim-type";
import { retrieveMatterSettingsQueryOptions } from "@/lib/data/react-query/matters/matter-settings";
import { getIncidentTypeLabel } from "@/lib/utils/matters/incident-classification";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

export function useReportClassificationLabels(
  incidentTypeIds: string[],
  claimTypeIds: string[],
  enabled: boolean,
) {
  const { data: settings } = useQuery({
    ...retrieveMatterSettingsQueryOptions(),
    enabled,
  });
  const { data: claims } = useQuery({
    ...retrieveClaimTypesQueryOptions(),
    enabled,
  });
  return useMemo(
    () => [
      ...incidentTypeIds.map((id) => ({
        dimension: "incidentType" as const,
        value: id,
        label: `Incident type: ${getIncidentTypeLabel((settings?.data.incidentTypes ?? []).find((type) => type.id === id) ?? { id })}`,
      })),
      ...claimTypeIds.map((id) => ({
        dimension: "claimType" as const,
        value: id,
        label: `Claim type: ${claims?.data.find((claim) => claim.id === id)?.label ?? id}`,
      })),
    ],
    [incidentTypeIds, claimTypeIds, settings, claims],
  );
}
